import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const WeatherWidget = ({
  iconCurrent,
  weather,
  day,
  temperature,
  minTemp,
  maxTemp,
  humidity,
  rain,
  wind,
  windDirection,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      height={200}
      width="auto"
      borderRadius={4}
      p={2}
      sx={{
        background: "linear-gradient(to bottom, #0082C7, #00AEDC)",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontWeight="bold" color="white">
          {day}
        </Typography>
        {iconCurrent && (
          <img src={iconCurrent} alt={weather} height={40} width={40} />
        )}
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontWeight="bold" variant="h5" color="white">
          {temperature}°
        </Typography>
        <Stack spacing={0.5} alignItems="end">
          <Typography variant="caption" color="white">
            Min {minTemp}°
          </Typography>
          <Typography variant="caption" color="white">
            Max {maxTemp}°
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="white">
          {t("weather-forecast.humidity")} %
        </Typography>
        <Typography color="white">{humidity}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="white">{t("weather-forecast.rain")}</Typography>
        <Typography color="white">{rain}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="white">{t("weather-forecast.wind")}</Typography>
        <Typography color="white">
          {wind} {windDirection}
        </Typography>
      </Stack>
    </Box>
  );
};

export default WeatherWidget;
